import { render, staticRenderFns } from "./ExplanationPopup.vue?vue&type=template&id=1fc991c2&scoped=true"
import script from "./ExplanationPopup.vue?vue&type=script&lang=ts"
export * from "./ExplanationPopup.vue?vue&type=script&lang=ts"
import style0 from "./ExplanationPopup.vue?vue&type=style&index=0&id=1fc991c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc991c2",
  null
  
)

export default component.exports